module.exports = __webpack_public_path__ + "static/img/ndvi0.72aed7a3.jpg";